import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchWorkHistories} from '../actions/workhistory'
import {changeFilterDatas} from '../actions/filter'
import WorkHistory from '../components/WorkHistory'

const mapStateToProps = state => {
  const { workhistory } = state
  const { filter } = state
  const {
    isFetching,
    lastUpdated,
    items,
    // totalRows,
    startDate
  } = workhistory || {
    isFetching: true,
    items: []
  }

  const {
    filters,
  } = filter || {
    filters: []
  }

  return {
    items,
    filters,
    isFetching,
    lastUpdated,
    // totalRows,
    startDate,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getWorkHistories: fetchWorkHistories,
      changeFilterDatas:changeFilterDatas,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(WorkHistory)
